import React, { useEffect, useState } from 'react';
import { BaSeDialogContext, BaSeIcon } from '@base/react';
import {
  ColumnGap,
  FilterClearButton,
  FilterContainer,
  FlexDirectionWrapper,
  MainContent,
  SubTitle,
  WrapperLegend,
  Text,
} from '../../../../../components/StyledComponents';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import { useHistory } from 'react-router-dom';
import Accordion from '@material-ui/core/Accordion';
import { ExcelExportAdmin } from '../../../../../components/ExcelExportAdmin';
import { formatDateToBR } from '../../../../../utils/time';
import { SearchInputAdmin } from '../../../../../components/SearchInputAdmin';
import { formatCPF, removeEmpty } from '../../../../../utils/utils';
import {
  formatDefaultValueSelect,
  numberLocale,
} from '../../../../../utils/mask';
import filtersModel from '../../../filters.model';
import { TableAdminReports } from '../../../../../components/TableAdmin/TableAdminReports';

import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { PerfilUsuarioService } from '../../../services/PerfilUsuarioService';
import { FaRegCheckCircle } from 'react-icons/fa';
import { handleModalAdmin } from '../../../../../utils/handleModalAdmin';
import { useApp } from '../../../../../context/app';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const GerenciarPerfilUsuarios = () => {
  const { setRenderIncludePerfilOrLista, setPerfilUsuariosOptions } = useApp();

  const {
    handleOrderClick,
    handleInputPageChange,
    handlePageChange,
    onLinesPerPageChange,
    filters,
    setFilters,
    paginationFilters,
    setPaginationFilters,
    inputSearchValue,
    setInputSearchValue,
    isLoading,
    setIsLoading,
    setFilterOptions,
    cleanSelectedFiltersFromModel,
    cleanFilters,
  } = filtersModel();

  const history = useHistory();
  const { showModal } = React.useContext(BaSeDialogContext);
  const [dataPerfil, setDataPerfil] = useState([]);
  const [dataLista, setDataLista] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [filterAtivo, setFilterAtivo] = useState('');

  const [value, setValue] = React.useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const getDataExcelPerfil = async () => {
    const nome = inputSearchValue;
    if (!filterAtivo) {
      const response = await PerfilUsuarioService.findAllPerfil(
        `?${!!nome ? 'nome=' + nome + '&' : ''}page=${
          paginationFilters.page
        }&linesPerPage=${paginationFilters.linesPerPage}&orderBy=${
          paginationFilters.orderBy
        }&direction=${paginationFilters.direction ? 'ASC' : 'DESC'}`,
        {
          ...cleanFilters(),
        }
      );
      return response?.content?.map((xls) => ({
        CODIGO: xls?.id,
        DATA: formatDateToBR(xls?.dataCriacao),
        PERFIL: formatDefaultValueSelect(xls?.nome),
        DESCRICAO: xls?.descricao,
        ATIVO: xls?.ativo === true ? 'ATIVO' : 'NÃO ATIVO',
      }));
    } else {
      const response = await PerfilUsuarioService.findAllPerfil(
        `?${!!nome ? 'nome=' + nome + '&' : ''}ativo=${filterAtivo}&page=${
          paginationFilters.page
        }&linesPerPage=${paginationFilters.linesPerPage}&orderBy=${
          paginationFilters.orderBy
        }&direction=${paginationFilters.direction ? 'ASC' : 'DESC'}`,
        {
          ...cleanFilters(),
        }
      );
      return response?.content?.map((xls) => ({
        CODIGO: xls?.id,
        DATA: formatDateToBR(xls?.dataCriacao),
        PERFIL: formatDefaultValueSelect(xls?.nome),
        DESCRICAO: xls?.descricao,
        ATIVO: xls?.ativo === true ? 'ATIVO' : 'NÃO ATIVO',
      }));
    }
  };

  const getDataExcelLista = async () => {
    const bodyParams = removeEmpty({
      ...filters,
      oqueVoceProcura: inputSearchValue,
    });
    const pageFilter = { ...paginationFilters, page: 0, linesPerPage: 1000 };
    const response = await PerfilUsuarioService.findAllLista(
      pageFilter,
      bodyParams
    );

    return response?.content?.map((xls) => ({
      CODIGO: xls?.administrador?.id,
      DATA: formatDateToBR(xls?.dataCriacao),
      PERFIL: formatDefaultValueSelect(xls?.perfil?.nome),
      CPF: formatCPF(xls?.administrador?.cpf),
      UF: xls?.administrador?.uf?.sigla,
      ATIVO: xls?.ativo === true ? 'ATIVO' : 'NÃO ATIVO',
    }));
  };

  // ABA 1
  const getDataPerfil = async () => {
    const nome = inputSearchValue;
    if (!filterAtivo) {
      const response = await PerfilUsuarioService.findAllPerfil(
        `?${!!nome ? 'nome=' + nome + '&' : ''}page=${
          paginationFilters.page
        }&linesPerPage=${paginationFilters.linesPerPage}&orderBy=${
          paginationFilters.orderBy
        }&direction=${paginationFilters.direction ? 'ASC' : 'DESC'}`,
        {
          ...cleanFilters(),
        }
      );
      setDataPerfil(response);
    } else {
      const response = await PerfilUsuarioService.findAllPerfil(
        `?${!!nome ? 'nome=' + nome + '&' : ''}ativo=${
          filterAtivo === 'REPROVADO' ? false : true
        }&page=${paginationFilters.page}&linesPerPage=${
          paginationFilters.linesPerPage
        }&orderBy=${paginationFilters.orderBy}&direction=${
          paginationFilters.direction ? 'ASC' : 'DESC'
        }`,
        {
          ...cleanFilters(),
        }
      );
      setDataPerfil(response);
      setPerfilUsuariosOptions(response);
    }

    setIsLoading(false);
  };

  // ABA 2
  const getDataLista = async (source) => {
    const bodyParams = removeEmpty({
      ...filters,
      oqueVoceProcura: inputSearchValue,
    });
    const response = await PerfilUsuarioService.findAllLista(
      paginationFilters,
      bodyParams,
      source
    );
    setIsLoading(false);
    setDataLista(response);
  };

  const getFilterOptionsData = async () => {
    setFilterOptions({});
    const response = await PerfilUsuarioService.getFilterOptions();
    setFilterOptions(response);
  };

  const onClickClearFilters = () => {
    setIsLoading(true);
    setDataPerfil([]);
    setInputSearchValue(null);
    setFilters({
      status: '',
    });
    setPaginationFilters({
      page: 0,
      linesPerPage: 10,
      orderBy: 'id',
      direction: 'DESC',
    });
    cleanSelectedFiltersFromModel();
    setFilterAtivo('');
  };

  useEffect(() => {
    setIsLoading(true);
    if (tabIndex === 0) {
      setDataPerfil([]);
      getDataPerfil();
      setRenderIncludePerfilOrLista(false);
    } else {
      setDataLista([]);
      getDataLista();
    }
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationFilters, filters, inputSearchValue, tabIndex, filterAtivo]);

  useEffect(() => {
    getFilterOptionsData();
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tableColumnsPerfil = [
    {
      field: 'id',
      id: 'id',
      label: 'Cód.',
      minWidth: 20,
    },
    {
      id: 'dataCriacao',
      field: 'dataCriacao',
      label: 'Data',
      minWidth: 20,
    },
    {
      id: 'nome',
      field: 'nome',
      label: 'Perfil',
      minWidth: 50,
    },
    {
      id: 'descricao',
      field: 'descricao',
      label: 'Descrição',
      minWidth: 150,
    },
    {
      field: 'actions',
      id: 'actions',
      label: 'Status',
      minWidth: 100,
    },
  ];
  const tableColumnsLista = [
    {
      field: 'administrador',
      subfield: 'id',
      id: 'administrador',
      label: 'Cód.',
      minWidth: 10,
    },
    {
      field: 'dataCriacao',
      id: 'dataCriacao',
      label: 'Data',
      minWidth: 10,
    },
    {
      id: 'perfil',
      field: 'perfil',
      subfield: 'nome',
      label: 'Perfil',
      minWidth: 100,
    },
    {
      id: 'administrador',
      field: 'administrador',
      subfield: 'nome',
      label: 'Nome',
      minWidth: 100,
    },
    {
      id: 'administrador',
      field: 'administrador',
      subfield: 'cpf',
      label: 'CPF',
      minWidth: 10,
      handleField: formatCPF,
    },
    {
      id: 'administrador',
      field: 'administrador',
      subfield: 'uf',
      subfield2: 'sigla',
      label: 'UF',
      minWidth: 10,
    },
    {
      field: 'actions',
      id: 'actions',
      label: 'Status',
      minWidth: 100,
    },
  ];

  const renderFilters = (color) => {
    return (
      <FilterContainer>
        <Accordion
          defaultExpanded={false}
          expanded={false}
          style={{ backgroundColor: '#F8F8F8', marginBottom: 20 }}
        >
          <AccordionSummary
            expandIcon={''}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <BaSeIcon
              name="filter"
              color={color}
              size={25}
              description="Ícone de filtro"
            />
            <p
              style={{ color: color, fontWeight: 'bold', marginTop: '0.2rem' }}
            >
              Filtrar
            </p>
            <FilterClearButton
              color={color}
              onClick={(e) => {
                e.stopPropagation();
                onClickClearFilters();
              }}
            >
              <BaSeIcon
                name="close"
                size={10}
                color={color}
                description="Limpar filtros"
              />
              <p
                style={{
                  fontSize: '12px',
                  color: color,
                  borderBottom: `1px solid ${color}`,
                }}
              >
                Limpar filtros
              </p>
            </FilterClearButton>
          </AccordionSummary>
        </Accordion>
      </FilterContainer>
    );
  };

  const changeVersionState = async (version, type) => {
    if (type === 'lista') {
      return await PerfilUsuarioService.changeStatusUsuario(
        version?.administrador?.id,
        version?.perfil?.id,
        !version?.ativo
      );
    }

    return await PerfilUsuarioService.changeStatus(version.id);
  };

  const handleStateClick = (item, type) => {
    console.log('handleStateClick', item);
    handleModalAdmin({
      title: `${!!item.ativo ? 'Desaprovar' : 'Aprovar'}`,
      content: `Ao ${!!item.ativo ? 'Desaprovar' : 'Aprovar'} esse este ${
        tabIndex === 0 ? 'perfil' : 'usuário'
      } ele ${
        !!item.ativo ? 'deixará de ser' : 'será'
      } apresentado no app. Deseja continuar?`,
      msgOnSuccess: `${tabIndex === 0 ? 'Perfil de usuário' : 'Usuário'} ${
        !!item.ativo ? 'Desaprovado' : 'Aprovado'
      } com sucesso`,
      msgOnError: `O ${
        tabIndex === 0 ? 'Perfil de usuário' : 'Usuário'
      } não foi ${
        !!item.ativo ? 'Desaprovado' : 'Aprovado'
      } Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.`,
      onFinish: () => {
        setIsLoading(true);
        if (tabIndex === 0) {
          getDataPerfil();
        } else {
          getDataLista();
        }
      },
      onConfirmClick: () => changeVersionState(item, type),
      onCancelClick: () => console.log('modal closed...'),
      showModal: showModal,
    });
  };

  const handleDeleteClick = (idPerfil, type) => {
    handleModalAdmin({
      title: `Excluir ${type === 'lista' ? 'usuário' : 'perfil de usuário'} `,
      content: `Você tem certeza que deseja excluir esse ${
        type === 'lista' ? 'usuário' : 'perfil de usuário'
      }?`,
      msgOnSuccess: `${
        type === 'lista' ? 'Usuário' : 'Perfil de usuário'
      } excluído com sucesso`,
      onFinish: () => {
        setIsLoading(true);
        if (tabIndex === 0) {
          getDataPerfil();
        } else {
          getDataLista();
        }
      },
      onConfirmClick: async () =>
        type === 'lista'
          ? await PerfilUsuarioService.deleteLista(
              idPerfil?.administrador?.cpf,
              idPerfil?.perfil?.id
            )
          : await PerfilUsuarioService.deletePerfil(idPerfil),
      onCancelClick: () => console.log('modal closed...'),
      showModal: showModal,
    });
  };

  const handleEditClick = (id, type) => {
    if (type === 'lista') {
      history.push(`/reports/lista/${id}/edit`);
      return;
    }
    history.push(`/reports/perfil/${id}/edit`);
  };

  return (
    <MainContent>
      <SubTitle color="#00ccff">
        <>
          <h3>Perfil de usuário</h3>
          <SearchInputAdmin
            value={inputSearchValue}
            onChange={setInputSearchValue}
            placeholder="Digite o que deseja buscar..."
            iconColor="#00ccff"
          />
        </>
      </SubTitle>

      {renderFilters('#B3B3B3')}

      <WrapperLegend>
        <ColumnGap gap="7px" padding="6px 10px"></ColumnGap>

        <FlexDirectionWrapper>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginRight: '10px',
            }}
            className="legenda-buttons"
            onClick={() => setFilterAtivo('APROVADO')}
          >
            <FaRegCheckCircle size={25} color="#37cd69" />
            <Text margin="4px" color="#B3B3B3">
              Aprovado
            </Text>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginRight: '10px',
            }}
            className="legenda-buttons"
            onClick={() => setFilterAtivo('REPROVADO')}
          >
            <FaRegCheckCircle size={25} color="#FF0000" />
            <Text margin="4px" color="#B3B3B3">
              Aguardando aprovação
            </Text>
          </div>
        </FlexDirectionWrapper>
      </WrapperLegend>

      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: '#00ccff' }}>
          <Tabs
            value={value}
            onChange={handleTabChange}
            aria-label="basic tabs example"
          >
            <Tab
              sx={{ color: '#00ccff' }}
              label="Perfil de usuários"
              {...a11yProps(0)}
              onClick={() => {
                setRenderIncludePerfilOrLista(false);
                setTabIndex(0);
              }}
            />
            <Tab
              sx={{ color: '#00ccff' }}
              label="Lista de usuários"
              {...a11yProps(1)}
              onClick={() => {
                setRenderIncludePerfilOrLista(true);
                setTabIndex(1);
              }}
            />
          </Tabs>
        </Box>

        {/* ABA 1 */}
        <TabPanel value={value} index={0}>
          <FlexDirectionWrapper
            style={{ justifyContent: 'space-between', marginTop: '12px' }}
          >
            <div>
              <p style={{ fontWeight: 'bold', color: '#00ccff' }}>
                {numberLocale(dataPerfil?.totalElements)}{' '}
                <strong className="find-results">
                  {' '}
                  resultados encontrados{' '}
                </strong>
              </p>
            </div>

            <ExcelExportAdmin
              filename={`Exportacao_Perfil_Usuários_${formatDateToBR(
                new Date()
              )}`}
              handleDataCallback={getDataExcelPerfil}
              isCsv
            />
          </FlexDirectionWrapper>

          <TableAdminReports
            data={dataPerfil}
            columnAction={'actions'}
            paginationFilters={paginationFilters}
            linesPerPageFilters={paginationFilters?.linesPerPage}
            pagination={true}
            totalPages={dataPerfil?.totalPages}
            columns={tableColumnsPerfil}
            isLoading={isLoading}
            tableColor={'#00ccff'}
            lineColor={'rgb(248,251,255, 0.9)'}
            onLinesPerPageChange={onLinesPerPageChange}
            onPagePreviousChange={handlePageChange}
            onPageNextChange={handlePageChange}
            handleOrderClick={handleOrderClick}
            onInputPageChange={handleInputPageChange}
            handleDeleteClick={handleDeleteClick}
            handleEditClick={handleEditClick}
            handleStateClick={handleStateClick}
            propertyColumnStatus="ativo"
            typeFilters="perfilUsuario"
          />
        </TabPanel>

        {/* ABA 2 */}
        <TabPanel value={value} index={1}>
          <FlexDirectionWrapper
            style={{ justifyContent: 'space-between', marginTop: '12px' }}
          >
            <div>
              <p style={{ fontWeight: 'bold', color: '#00ccff' }}>
                {numberLocale(dataLista?.totalElements)}{' '}
                <strong className="find-results">
                  {' '}
                  resultados encontrados{' '}
                </strong>
              </p>
            </div>

            <ExcelExportAdmin
              filename={`Exportacao_Lista_Usuários_${formatDateToBR(
                new Date()
              )}`}
              handleDataCallback={getDataExcelLista}
              isCsv
            />
          </FlexDirectionWrapper>

          <TableAdminReports
            sentEntireObjectToEdit={true}
            data={dataLista}
            columnAction={'actions'}
            paginationFilters={paginationFilters}
            linesPerPageFilters={paginationFilters?.linesPerPage}
            pagination={true}
            totalPages={dataLista?.totalPages}
            columns={tableColumnsLista}
            isLoading={isLoading}
            tableColor={'#00ccff'}
            lineColor={'rgb(248,251,255, 0.9)'}
            onLinesPerPageChange={onLinesPerPageChange}
            onPagePreviousChange={handlePageChange}
            onPageNextChange={handlePageChange}
            handleOrderClick={handleOrderClick}
            onInputPageChange={handleInputPageChange}
            handleDeleteClick={(item) => handleDeleteClick(item, 'lista')}
            handleEditClick={(item) =>
              handleEditClick(item?.administrador?.id, 'lista')
            }
            handleStateClick={(item) => handleStateClick(item, 'lista')}
            propertyColumnStatus="ativo"
            typeFilters="perfilUsuarioLista"
          />
        </TabPanel>
      </Box>
    </MainContent>
  );
};
